import { getFirstElement } from '~utils/array';

export const getFreeProduct = userBenefits => {
  const benefit = userBenefits?.find(userBenefit => userBenefit?.minAmount);
  return benefit
    ? {
        minAmount: benefit?.minAmount,
        ...getFirstElement(benefit?.products)
      }
    : null;
};
